














































































































































































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { Project } from '@/api/model/project'
import { ProjectAPI } from '@/api/backend-client'
import { ProjectMortgageService } from '@/api/model/project-mortgage-service'
import { ProjectAppraisalService } from '@/api/model/project-appraisal-service'
import { Branch } from '@/api/model/branch'
import { cloneDeep, isEqual } from 'lodash'
import { gsap } from 'gsap'
import { ProjectEmailTemplate } from '@/api/model/project-email-template'

@Component
export default class EditProjectForm extends Vue {
    @Prop({ required: true }) readonly value!: Project
    project: Project = null
    submitting: boolean = false
    mortgageServiceChecked: boolean = false
    mortgageSelectedBranches: Branch[] = []
    appraisalServiceChecked: boolean = false
    appraisalSelectedBranch: Branch = null
    showProjectEmailTemplateModal: boolean = false
    editingProjectEmailTemplate: ProjectEmailTemplate = null

    created(): void {
        this.onValueChanged()
    }

    @Watch('showProjectEmailTemplateModal')
    autoSelectFirstTemplate() {
        if (this.showProjectEmailTemplateModal === false) {
            return
        }

        if (this.editingProjectEmailTemplate) {
            return
        }

        if (this.filteredTemplates.length === 0) {
            return
        }

        this.editingProjectEmailTemplate = this.filteredTemplates[0]
    }

    updateCurrentProjectEmailTemplate(html: string): void {
        if (this.editingProjectEmailTemplate === null) {
            return
        }

        this.project.emailTemplates
            .filter(template => template.type === this.editingProjectEmailTemplate.type)[0]
            .body = html
    }

    @Watch('value')
    onValueChanged(): void {
        this.submitting = false
        this.project = cloneDeep(this.value)
        this.mortgageServiceChecked = false
        this.mortgageSelectedBranches = []
        this.appraisalServiceChecked = false
        this.appraisalSelectedBranch = null

        if (this.project.mortgageService !== null) {
            this.mortgageServiceChecked = true
            this.mortgageSelectedBranches = this.project.mortgageService.branches
        }

        if (this.project.appraisalService !== null) {
            this.appraisalServiceChecked = true
            this.appraisalSelectedBranch = this.project.appraisalService.branch
        }
    }

    @Watch('project.active')
    onActiveChanged(): void {

        // Automatically turn off services when disabling personal pages.
        if (this.project.active === false) {
            this.mortgageServiceChecked = false
            this.appraisalServiceChecked = false
            this.project.mortgageService = null
            this.project.appraisalService = null
            this.mortgageSelectedBranches = []
            this.appraisalSelectedBranch = null
        }
    }

    onMortgageServiceChange(): void {

        // Clear service when disabled.
        if (this.mortgageServiceChecked === false) {
            this.mortgageSelectedBranches = []
            this.project.mortgageService = null
            return
        }

        // Create model if not yet exists.
        if (this.mortgageServiceChecked && this.project.mortgageService === null) {
            this.project.mortgageService = new ProjectMortgageService([ /* branches */])
        }
    }

    onAppraisalServiceChange(): void {

        // Clear service when disabled.
        if (this.appraisalServiceChecked === false) {
            this.project.appraisalService = null
            return
        }

        // Create model if not yet exists.
        if (this.appraisalServiceChecked && this.project.appraisalService === null) {
            this.project.appraisalService = new ProjectAppraisalService(null /* branch */)
        }
    }


    async saveProject(): Promise<void> {
        try {
            this.submitting = true

            if (this.mortgageServiceChecked) {
                this.project.mortgageService.branches = this.mortgageSelectedBranches
            }

            if (this.appraisalServiceChecked) {
                this.project.appraisalService.branch = this.appraisalSelectedBranch
            }

            await ProjectAPI.update(this.project.id, this.project)
            await this.$emit('save')

        } catch (error) {
            this.submitting = false
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: error.message,
            })
        }
    }

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(element, {
            opacity: 0,
            top: `-12rem`,
        })

        gsap.to(element, {
            duration: .4,
            opacity: 1,
            top: `-8rem`,
            ease: 'back.out',
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(element, {
            duration: .4,
            opacity: 0,
            top: `-12rem`,
            ease: 'back.out',
            onComplete,
        })
    }

    get optionsActive() {
        return [
            {
                label: this.$t('yes'),
                value: true,
            },
            {
                label: this.$t('no'),
                value: false,
            },
        ]
    }

    get filteredTemplates(): ProjectEmailTemplate[] {
        return this.project.emailTemplates
            .filter(emailTemplate => emailTemplate.type === 'project-services-introduction')
    }

    get availableBranches(): Branch[] {
        return this.$currentCompany.getAvailableBranches()
            .filter(branch => branch instanceof Branch)
            .sort((a: Branch, b: Branch) => a.name.localeCompare(b.name))
    }

    get formHasChanges(): boolean {
        return isEqual(this.value, this.project) === false
    }
}
